module.exports = __webpack_public_path__ + "static/media/tachometer-slowest.e8217ef3.svg";